// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.83cea4160',
  revision: '83cea4160',
  branch: 'develop',
  date: 'Mon, 14 Sep 2026 14:18:30 GMT'
};